import { cloneDeep, set } from 'lodash-es';

import { sharedCoverLetterClientDocumentVariable } from '@xing-com/crate-lebenslauf-shared-client-document-variable';

import { sharedClientDocumentVariableWithLocalStorage } from './sharedClientDocumentVariableWithLocalStorage';

export const updateLocalStorage = (key: string, newValue: any): void => {
  const doc = sharedCoverLetterClientDocumentVariable();
  const updatedDoc = cloneDeep(doc);

  set(updatedDoc, key, newValue);
  sharedClientDocumentVariableWithLocalStorage(updatedDoc);
};
